import React, { useState } from 'react';
import cx from 'classnames';
import CheckIcon from 'images/check_icon_purple.svg';
import { uniqueId } from 'lodash';

import ArrowDownSmallIcon from '../../images/ArrowDownSmallIcon.svg';

interface Props {
  items: string[];
  item?: string;
  onChange: (el: string) => void;
}

// TODO move to ui kit and add generic prop
export const Dropdown: React.FC<Props> = ({ items, item, onChange }) => {
  const [open, setOpen] = useState(false);

  const handleChange = (el: string) => {
    onChange(el);
    setOpen(false);
  };

  return (
    <>
      {open && <div className="fixed inset-0 z-0" onClick={() => setOpen(false)} />}
      <div className="w-full relative">
        <div
          className={cx(
            'flex-1 bg-black-2 hover:bg-white-10 rounded-[8px] border-[.5px] flex items-center w-full relative',
            open ? 'border-primary' : 'border-black-4'
          )}
        >
          <button
            className="flex items-center gap-8 w-full h-48 px-8 sm:px-16"
            onClick={() => setOpen((prevState) => !prevState)}
          >
            <div className="text-r14 ">{item}</div>
            <img className="w-16 h-16 ml-auto" src={ArrowDownSmallIcon} alt="" />
          </button>
        </div>
        {open && (
          <div
            className={cx(
              'w-full absolute top-52 bg-black-3 z-50 border border-black-4 rounded-[12px] max-h-[240px] overflow-y-auto'
            )}
          >
            {items.map((el, index) => {
              return (
                <div
                  key={uniqueId(el)}
                  className="flex items-center px-8 py-12 gap-8 cursor-pointer hover:bg-white-10"
                  onClick={() => handleChange(el)}
                >
                  <span className="text-m13 text-white">{el}</span>
                  {(el === item || '') && <img src={CheckIcon} alt="" className="ml-auto" />}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
};
